import { render } from "./ShippingCodes.vue?vue&type=template&id=54ae3b77"
import script from "./ShippingCodes.vue?vue&type=script&lang=js"
export * from "./ShippingCodes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ShippingCodes/ShippingCodes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54ae3b77"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54ae3b77', __exports__)) {
    api.reload('54ae3b77', __exports__)
  }
  
  module.hot.accept("./ShippingCodes.vue?vue&type=template&id=54ae3b77", () => {
    api.rerender('54ae3b77', render)
  })

}


export default __exports__